import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '../shared/api-client.js';

export function createApplicationQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) =>
          !(error instanceof ApiError && error.status === 403) && failureCount < 3,
        staleTime: 30_000,
      },
    },
  });
}
